import buildQuery from 'odata-query';

import { IRequestConfig } from 'models/Axios';
import { IDomainSetting } from 'models/DomainSetting';
import Services from './index.service';

export default class DomainSettingService extends Services<
  any,
  IDomainSetting
> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 50;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<IDomainSetting> = {
      url: `/domain-settings${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

  getUnblockedDistributionCenters = (clientId?: string) => {
    const config: IRequestConfig<IDomainSetting> = {
      baseUrl: this.mafraq_url,
      url: `/Budget/blocked-branches/${clientId}`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return this.httpRequest(config);
  };

  initialAlert = () => {
    const config: IRequestConfig<IDomainSetting> = {
      url: `/domain-settings/initial-alert`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return this.httpRequest(config);
  };
}
